import React, { useEffect } from 'react';
import './Notification.css';

export type NotificationKind = 'success' | 'error' | 'info';

interface NotificationProps {
  kind?: NotificationKind;
  message: string;
  onClose?: () => void;
  autoHideMs?: number;
}

const Notification: React.FC<NotificationProps> = ({ kind = 'info', message, onClose, autoHideMs = 4000 }) => {
  useEffect(() => {
    if (!autoHideMs) return;
    const t = setTimeout(() => onClose && onClose(), autoHideMs);
    return () => clearTimeout(t);
  }, [autoHideMs, onClose]);

  if (!message) return null;

  return (
    <div className={`notification notification-${kind}`} role="status">
      <span className="notification-text">{message}</span>
      {onClose && (
        <button className="notification-close" aria-label="Dismiss" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default Notification;
